import { Col } from "@commonlibs";
import styled, { css } from "styled-components";

export const FormScaffoldFormGridWrapper = styled(Col)(
    ({ theme }) => css`
        row-gap: ${theme.spacing["6"]};
        flex: 1;
    `,
);
